
import '../styles/main.scss';
import $ from 'jquery';
import likely from 'ilyabirman-likely';
import './issues';
import './video-player';
likely.initiate();